"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
exports.multiSsrPayloadFactory = multiSsrPayloadFactory;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ssrPayloadFactory(travellerState) {
  var _travellerState$ssr, _travellerState$ssr2, _travellerState$ssr3, _travellerState$ssr4;
  if (travellerState !== null && travellerState !== void 0 && travellerState.isInfant) {
    return undefined;
  }
  return {
    seatIndex: travellerState === null || travellerState === void 0 ? void 0 : travellerState.seatIndex,
    frequentFlyer: frequentFlyerPayloadFactory(travellerState === null || travellerState === void 0 ? void 0 : (_travellerState$ssr = travellerState.ssr) === null || _travellerState$ssr === void 0 ? void 0 : _travellerState$ssr.frequentFlyer),
    meal: mealFactoryPayloadFactory(travellerState === null || travellerState === void 0 ? void 0 : (_travellerState$ssr2 = travellerState.ssr) === null || _travellerState$ssr2 === void 0 ? void 0 : _travellerState$ssr2.meal),
    specialRequest: specialRequestPayloadFactory(travellerState === null || travellerState === void 0 ? void 0 : (_travellerState$ssr3 = travellerState.ssr) === null || _travellerState$ssr3 === void 0 ? void 0 : _travellerState$ssr3.specialRequest),
    luggage: luggagePayloadFactory(travellerState === null || travellerState === void 0 ? void 0 : (_travellerState$ssr4 = travellerState.ssr) === null || _travellerState$ssr4 === void 0 ? void 0 : _travellerState$ssr4.luggage)
  };
}
function multiSsrPayloadFactory(travellerState) {
  if (travellerState !== null && travellerState !== void 0 && travellerState.isInfant) {
    return undefined;
  }
  var payload = (0, _map2.default)((0, _get2.default)(travellerState, "products"), function (product, productId) {
    var _product$ssr, _product$ssr2, _product$ssr3, _product$ssr4;
    return {
      productId: productId,
      items: [{
        seatIndex: travellerState === null || travellerState === void 0 ? void 0 : travellerState.seatIndex,
        frequentFlyer: frequentFlyerPayloadFactory(product === null || product === void 0 ? void 0 : (_product$ssr = product.ssr) === null || _product$ssr === void 0 ? void 0 : _product$ssr.frequentFlyer),
        meal: mealFactoryPayloadFactory(product === null || product === void 0 ? void 0 : (_product$ssr2 = product.ssr) === null || _product$ssr2 === void 0 ? void 0 : _product$ssr2.meal),
        specialRequest: specialRequestPayloadFactory(product === null || product === void 0 ? void 0 : (_product$ssr3 = product.ssr) === null || _product$ssr3 === void 0 ? void 0 : _product$ssr3.specialRequest),
        luggage: luggagePayloadFactory(product === null || product === void 0 ? void 0 : (_product$ssr4 = product.ssr) === null || _product$ssr4 === void 0 ? void 0 : _product$ssr4.luggage)
      }]
    };
  });
  return payload;
}
function frequentFlyerPayloadFactory(frequentFlyerState) {
  var number = frequentFlyerState === null || frequentFlyerState === void 0 ? void 0 : frequentFlyerState.number;
  var operatorCode = frequentFlyerState === null || frequentFlyerState === void 0 ? void 0 : frequentFlyerState.operatorCode;
  if (!number || !operatorCode || !/^[0-9a-zA-Z\s]*$/.test(number)) {
    return undefined;
  }
  return {
    membershipNumber: [operatorCode, number].join(_constants.FREQUENT_FLYER_SEPARATOR)
  };
}
function mealFactoryPayloadFactory(mealState) {
  var value = mealState === null || mealState === void 0 ? void 0 : mealState.value;
  var label = mealState === null || mealState === void 0 ? void 0 : mealState.label;
  if (!value || !label) {
    return undefined;
  }
  return {
    value: value,
    label: label
  };
}
function specialRequestPayloadFactory(specialRequestState) {
  var value = specialRequestState === null || specialRequestState === void 0 ? void 0 : specialRequestState.value;
  var label = specialRequestState === null || specialRequestState === void 0 ? void 0 : specialRequestState.label;
  if (!value || !label) {
    return undefined;
  }
  return {
    value: value,
    label: label
  };
}
function luggagePayloadFactory(luggageState) {
  var luggagePayload = [];
  (0, _each2.default)(luggageState, function (luggageItem) {
    if ((0, _isPlainObject2.default)(luggageItem) && (0, _isPlainObject2.default)(luggageItem.selectedOption)) {
      luggagePayload.push(_objectSpread(_objectSpread({}, luggageItem), {}, {
        selectedOption: luggageItem.selectedOption.apiPayload
      }));
    }
  });
  return (0, _isEmpty2.default)(luggagePayload) ? undefined : luggagePayload;
}
var _default = exports.default = ssrPayloadFactory;